import TextField, { TextFieldProps } from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';

export const NumericInput: React.FC<TextFieldProps> = React.forwardRef(
  (props: TextFieldProps, ref) => {
    const [value, setValue] = useState<string>('');
    const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value: inputValue } = event.target;
      const newValue = inputValue.replace(/[^0-9]/g, '');
      setValue(newValue);
    };

    useEffect(() => {
      if (!isNaN(Number(props.value))) {
        setValue(props.value?.toString() || '');
      }
    }, [props.value]);

    return (
      <TextField
        {...props}
        ref={ref}
        type="text"
        value={value}
        onInput={handleInput}
      />
    );
  }
);
